import RecipientExpansionStatus from 'owa-recipient-types/lib/types/RecipientExpansionStatus';
import { SharingTipRecipientInfo } from '../../types/SharingTipRecipientInfo';
import { getGroupsAndSmallDLs } from './getGroupsAndSmallDLs';

export function hasRecipientExpansionFailure(recipientInfo: SharingTipRecipientInfo[]): boolean {
    return getGroupsAndSmallDLs(recipientInfo, true /* shouldLookForMailboxType */).some(function (
        smallDL
    ) {
        return (
            smallDL.recipient.expansionStatus === RecipientExpansionStatus.Failed ||
            smallDL.recipient.expansionStatus ===
                RecipientExpansionStatus.SucceededWithDLOrGroupMembers
        );
    });
}
